<template>
  <GbwapsLayout
    title="GB WhatsApp FAQ – Common Questions & Answers 2026"
    :intro="pageIntro"
    :breadcrumb="breadcrumb"
  >
    <div class="faq-page">
      <p class="faq-lead">
        Browse 50 answers across download, install, safety, bans, features, and troubleshooting. Each section opens
        with the first question expanded—tap any heading to read more.
      </p>

      <nav class="faq-toc card" aria-label="FAQ categories">
        <h2 class="faq-toc-title">Jump to category</h2>
        <ul>
          <li v-for="cat in categories" :key="cat.id">
            <a :href="'#faq-' + cat.id">{{ cat.h2 }}</a>
          </li>
        </ul>
      </nav>

      <section
        v-for="cat in categories"
        :id="'faq-' + cat.id"
        :key="cat.id"
        class="faq-section page-section site-section"
      >
        <h2>{{ cat.h2 }}</h2>
        <FaqAccordion :items="cat.items" />
        <p class="faq-category-links">
          <span>Related:</span>
          <template v-for="(link, idx) in cat.footerLinks">
            <router-link :key="link.to" :to="link.to">{{ link.text }}</router-link>
            <span v-if="idx < cat.footerLinks.length - 1" :key="link.to + '-sep'"> · </span>
          </template>
        </p>
      </section>
    </div>
  </GbwapsLayout>
</template>

<script>
import '@/css/gbwaps/pages.css';
import GbwapsLayout from '@/layouts/GbwapsLayout.vue';
import FaqAccordion from '@/components/gbwaps/FaqAccordion.vue';
import { FAQ_CATEGORIES } from '@/data/faq-content';

export default {
  name: 'FaqPage',
  components: { GbwapsLayout, FaqAccordion },
  data() {
    return {
      pageIntro:
        'Find answers to common questions about GB WhatsApp download, installation, safety, features, bans, and updates.',
      breadcrumb: [{ name: 'Home', to: '/' }, { name: 'FAQ' }],
      categories: FAQ_CATEGORIES,
    };
  },
};
</script>

<style scoped>
.faq-lead {
  margin-bottom: 1.5rem;
  color: var(--text-muted, #555);
  line-height: 1.6;
}

.faq-toc {
  margin-bottom: 2rem;
  padding: 1.25rem 1.5rem;
}

.faq-toc-title {
  font-size: 1.1rem;
  margin: 0 0 0.75rem;
}

.faq-toc ul {
  margin: 0;
  padding-left: 1.25rem;
  line-height: 1.8;
}

.faq-toc a {
  color: var(--dark-green, #075e54);
  text-decoration: none;
}

.faq-toc a:hover {
  text-decoration: underline;
}

.faq-section + .faq-section {
  margin-top: 2.5rem;
  padding-top: 0.5rem;
  border-top: 1px solid rgba(7, 94, 84, 0.12);
}

.faq-category-links {
  margin-top: 1rem;
  font-size: 0.95rem;
  color: var(--text-muted, #555);
}

.faq-category-links span {
  margin-right: 0.35rem;
}

.faq-category-links a {
  color: var(--dark-green, #075e54);
  font-weight: 600;
  text-decoration: none;
}

.faq-category-links a:hover {
  text-decoration: underline;
}
</style>
